import {AppLayout} from "../layout/AppLayout.tsx";
import {PublicHomePage} from "../features/home/pages/PublicHomePage.tsx";
import {SignOutPage} from "../features/home/pages/SignOutPage.tsx";
import {RequireAuth} from "../utils/RequireAuth.tsx";
import {IndexPage as DashboardPage} from "../features/dashboard/pages/IndexPage.tsx";
import {ApplicationsLayout} from "../features/applications/layout.tsx";
import {OrganizationsLayout} from "../features/organizations/layout.tsx";
import {AccountsLayout} from "../features/accounts/layout.tsx";
import {UsersLayout} from "../features/users/layout.tsx";
import {PlaybooksLayout} from "../features/playbooks/layout.tsx";
import {ExecutionsLayout} from "../features/executions/layout.tsx";
import {PipelinesLayout} from "../features/devops/pipelines/layout.tsx";
import {CodeRepositoriesLayout} from "../features/devops/code-repositories/layout.tsx";
import {CodePipelinesLayout} from "../features/devops/code-pipelines/layout.tsx";
import {ApplicationErrorPage} from "@flexinet/ui-components";
import {IndexPage as AnalyticsPage} from "../features/analytics/pages/IndexPage.tsx";
import {ApplicationScreenshotsLayout} from "../features/application-screenshots/layout.tsx";
import {DeploymentAccountGroupsLayout} from "../features/devops/deployment-account-groups/layout.tsx";
import {TestingActionsLayout} from "../features/testing-actions/layout.tsx";
import {TestingRegistryLayout} from "../features/testing-registry/layout.tsx";
import {TestingPersonasLayout} from "../features/testing-personas/layout.tsx";
import {TestDefinitionsLayout} from "../features/testing-test-definitions/layout.tsx";
import {SyntheticUsersLayout} from "../features/synthetic-users/layout.tsx";
import {TestObservationsLayout} from "../features/test-observations/layout.tsx";
import {TestRunsLayout} from "../features/testing-runs/layout.tsx";
import {DefectSignaturesLayout} from "../features/defect-signatures/layout.tsx";
import {PlatformControlsLayout} from "../features/platform-controls/layout.tsx";


export const routesConfig = [{
    path: '/',
    element: <AppLayout/>,
    errorElement: <ApplicationErrorPage/>,
    children: [{
        index: true,
        element: <PublicHomePage/>
    }, {
        path: 'sign-out',
        element: <SignOutPage/>
    }, {
        path: 'dashboard',
        element: <RequireAuth><DashboardPage/></RequireAuth>
    }, {
        path: 'applications/*',
        element: <RequireAuth><ApplicationsLayout/></RequireAuth>
    }, {
        path: 'organizations/*',
        element: <RequireAuth><OrganizationsLayout/></RequireAuth>
    }, {
        path: 'accounts/*',
        element: <RequireAuth><AccountsLayout/></RequireAuth>
    }, {
        path: 'users/*',
        element: <RequireAuth><UsersLayout/></RequireAuth>
    }, {
        path: 'playbooks/*',
        element: <RequireAuth><PlaybooksLayout/></RequireAuth>
    }, {
        path: 'executions/*',
        element: <RequireAuth><ExecutionsLayout/></RequireAuth>
    }, {
        path: 'pipelines/*',
        element: <RequireAuth><PipelinesLayout/></RequireAuth>
    }, {
        path: 'code-pipelines/*',
        element: <RequireAuth><CodePipelinesLayout/></RequireAuth>
    }, {
        path: 'code-repositories/*',
        element: <RequireAuth><CodeRepositoriesLayout/></RequireAuth>
    }, {
        path: 'deployment-account-groups/*',
        element: <RequireAuth><DeploymentAccountGroupsLayout/></RequireAuth>
    }, {
        path: 'application-screenshots/*',
        element: <RequireAuth><ApplicationScreenshotsLayout/></RequireAuth>
    }, {
        path: 'testing-actions/*',
        element: <RequireAuth><TestingActionsLayout/></RequireAuth>
    }, {
        // FNP-995: the handler registry — read-only, one route.
        path: 'testing-registry/*',
        element: <RequireAuth><TestingRegistryLayout/></RequireAuth>
    }, {
        path: 'testing-personas/*',
        element: <RequireAuth><TestingPersonasLayout/></RequireAuth>
    }, {
        path: 'test-definitions/*',
        element: <RequireAuth><TestDefinitionsLayout/></RequireAuth>
    }, {
        path: 'synthetic-users/*',
        element: <RequireAuth><SyntheticUsersLayout/></RequireAuth>
    }, {
        path: 'test-observations/*',
        element: <RequireAuth><TestObservationsLayout/></RequireAuth>
    }, {
        path: 'test-runs/*',
        element: <RequireAuth><TestRunsLayout/></RequireAuth>
    }, {
        path: 'defects/*',
        element: <RequireAuth><DefectSignaturesLayout/></RequireAuth>
    }, {
        path: 'platform-controls/*',
        element: <RequireAuth><PlatformControlsLayout/></RequireAuth>
    }, {
        path: 'analytics/*',
        element: <RequireAuth><AnalyticsPage/></RequireAuth>,
    }]
}]